export default __webpack_public_path__ + "static/media/solana-icon.b7576261.png";